import React from "react";

export const RenderNothing = <React.Fragment />;
